import * as React from 'react';

const CloseSmallIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0604 4.35355C13.2557 4.15829 13.2557 3.84171 13.0604 3.64645C12.8652 3.45118 12.5486 3.45118 12.3533 3.64645L8.70631 7.29345L5.0593 3.64645C4.86404 3.45118 4.54746 3.45118 4.3522 3.64645C4.15693 3.84171 4.15693 4.15829 4.3522 4.35355L7.9992 8.00056L4.3522 11.6476C4.15693 11.8428 4.15693 12.1594 4.3522 12.3547C4.54746 12.5499 4.86404 12.5499 5.0593 12.3547L8.70631 8.70766L12.3533 12.3547C12.5486 12.5499 12.8652 12.5499 13.0604 12.3547C13.2557 12.1594 13.2557 11.8428 13.0604 11.6476L9.41341 8.00056L13.0604 4.35355Z"
      fill="white"
    />
  </svg>
);

export default CloseSmallIcon;
